<template>
    <div class="quiz_main" v-bind:style="{backgroundColor:getCourseMainColor(courseId)}">
        <div class="navigation" v-bind:style="{backgroundColor:getCourseMainColor(courseId), height:getNavCount()+'px', 'margin-top': isWeixinBrowser() ? '15px' : '0px'}" fixed>
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><img src="@/Images/icon_white_back.png"/></div>
            <div class="content">{{lessonTitle}} Quiz</div>
            <div v-if="!isNoGetData && !isEmpty(wordsQuizArray) && objWordsQuizResult == null"
                    v-bind:class="{'right' :!isFinishInput(), 'right_post': isFinishInput()}"
                 :style="{'margin-top': getStateHeight()/2 + 'px'}" @click="nextClick">提交</div>
            <div class="clear"></div>
        </div>
        <div v-if="isNoGetData || (!isEmpty(wordsQuizArray) && objWordsQuizResult == null)">
            <div class="quiz_main_content">
                <div class="Page_num"><div class="content_center"><span>{{wordIndex}}</span>/{{wordsQuizArray.length}}</div></div>
                <div class="imgLazyLoadHead" @click="playAudio">
                    <img class="img_show" v-lazy="getImgUrl()">
                    <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/word_course_volume3.png" height="30" width="30"/>
                    <audio v-bind:src="getAudioUrl()" id="musicMp3" autoplay="" controls="" @play="playStart"  @ended="playEnded"></audio>
                </div>
                <div class="input_letter">
                    <div  v-if="noShowGuideInputLetter == 0 && inputLettersArray.length > 0"  class="bubbleContainer" @click="inputLetterGuideClick">
                        <div class="text">点字母可以清除</div>
                        <div class="img"><img src="../../../assets/play_arrow.png"/></div>
                    </div>
                    <div v-bind:class="{'input_letter_item' :true, 'input_letter_itembg': isSpecialChar(item) ? false : true}"  v-bind:style="{width:getInputSize(), 'padding-top':getInputSize(), 'margin-left':index == 0 ? '0px' : '5px'}"
                         v-for="(item,index) in getWord()" :key="index"
                         @click="inputLetterClick(index)"><span v-bind:id="forInputLetterId(index)">{{isSpecialChar(item) ? item : getCurrentInputLetter(index)}}</span></div>
                </div>
                <div class="keyboard_letters2">
                    <div  v-if="noShowGuidekeyBoardLetter == 0"  class="bubbleContainer" @click="keyBoardLetterGuideClick">
                        <div class="text">点字母选择</div>
                        <div class="img"><img src="../../../assets/play_arrow.png"/></div>
                    </div>
                    <div class="keyboard_letters">
                        <div class="keyboard_letters_item" v-bind:style="{width:getKeyboardLettersSize(), 'padding-top':getKeyboardLettersSize(),
                 'margin-left':index%keyboardLettersRowCount == 0 ? '0px' : '5px', 'background-color':isContainkeyboardLetter(index, item) ? '#c7c7c7' : 'white'}"
                             v-for="(item,index) in getKeyboardLettersArray()" :key="index"
                             @click="keyboardLettersClick(index, item)">
                            <span>{{isContainkeyboardLetter(index, item) ? "" : item}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="(!isNoGetData && isEmpty(wordsQuizArray)) || (objWordsQuizResult != null && getCount(objWordsQuizResult.wrongCount) == 0)" class="quiz_main_right">
            <div class="content">
                <div class="top"></div>
                <div class="answer">
                    <div class="answer_right">答对<br/>{{quizCount}}</div>
                    <div class="answer_wrong">答错<br/>{{0}}</div>
                    <div class="clear"></div>
                </div>
                <div class="tip">全部答对，祝贺！</div>
                <div class="finish" @click="finishClick">完成</div>
                <div class="restart" @click="restartClick">重新开始</div>
            </div>
            <div class="img"><img src="../../../assets/quiz_all_right.png"/></div>
        </div>
        <div v-if="objWordsQuizResult != null && getCount(objWordsQuizResult.wrongCount) > 0" class="quiz_main_wrong">
            <div class="content">
                <div class="top"></div>
                <div class="answer">
                    <div class="answer_right">答对<br/>{{objWordsQuizResult != null ? getCount(objWordsQuizResult.rightCount) : 0}}</div>
                    <div class="answer_wrong">答错<br/>{{objWordsQuizResult != null ? getCount(objWordsQuizResult.wrongCount) : 0}}</div>
                    <div class="clear"></div>
                </div>
                <div class="tip">这些题目，要再做一遍哦<br/><span>{{objWordsQuizResult != null ? objWordsQuizResult.wrongSubjects : ""}}</span></div>
                <div class="continue" @click="continueClick">继续</div>
            </div>
            <div class="img"><img src="../../../assets/quiz_noall_right.png"/></div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { Indicator } from 'mint-ui';
    import { MessageBox } from 'mint-ui';

    function getUrl(lessonId, deleteRecords) {
        return "240words/getQuiz/" + lessonId + "/" + deleteRecords;
    }

    export default {
        name: "index",
        data() {
            return {
                courseId:0,
                lessonId:0,
                quizCount:0,
                lessonTitle:"",
                isNoGetData:true,
                wordsQuizArray:[],
                deleteRecords:0,
                wordIndex:1,
                keyboardLettersRowCount:7,
                forInputLetterBase:"for_inputletter_",
                inputLettersArray:[],
                showWordsQuizView:true,
                objWordsQuizResult:null,
                postDataArray:[],
                isPlaying: false,
                noShowGuideInputLetter:1,
                noShowGuidekeyBoardLetter:1
            }
        },
        methods:{
            goBack:function () {
                let that = this;

                if (that.isNoGetData || (!that.isEmpty(that.wordsQuizArray) && that.objWordsQuizResult == null)) {
                    that.confirmbox();
                } else {
                    that.$router.go(-1);
                }
            },
            getStateHeight:function(){
                return this.getCount(this.$store.state.statusheight);
            },
            getNavCount:function() {
                return this.getStateHeight() + 44;
            },
            inputLetterGuideClick:function(){
                let that = this;

                if (that.noShowGuideInputLetter === 1) {
                    return;
                }

                that.$axios.get("240words/saveGuidePrompt/key5").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideInputLetter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            keyBoardLetterGuideClick:function() {
                let that = this;

                if (that.noShowGuidekeyBoardLetter === 1) {
                    return;
                }

                that.$axios.get("240words/saveGuidePrompt/key6").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuidekeyBoardLetter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            nextClick:function() {
                let that = this;

                if (!that.isFinishInput()) {
                    return;
                }

                let isAddPostData = false;
                let objWordsQuiz = that.getWordsQuiz()
                let strInput = that.getInputLetters();

                that.postDataArray.forEach((item) => {
                    if (item.pk === objWordsQuiz.pk) {
                        item.name = strInput;
                        isAddPostData = true;
                    }
                })

                if (!isAddPostData) {
                    that.postDataArray.push({pk:objWordsQuiz.pk, name:strInput});
                }

                if (that.wordIndex < that.wordsQuizArray.length) {
                    that.wordIndex++;
                    that.inputLettersArray = [];
                } else {
                    that.submitQuiz();
                }
            },
            confirmbox () {
                let that = this;
                MessageBox.confirm('', {
                    message: ' ',
                    title: '退出后，下次将重新开始挑战哦~',
                    showConfirmButton:true,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    confirmButtonText:'离开',
                    cancelButtonText:'继续挑战'
                }).then(action => {
                    if (action == 'confirm') {
                        window.console.log("离开")
                        that.$router.go(-1);
                    }
                }).catch(err => {
                    if (err == 'cancel') {
                        window.console.log("继续挑战")
                    }
                });
            },
            submitQuiz:function() {
                let that = this;

                if (that.isEmpty(that.postDataArray)) {
                    return;
                }

                Indicator.open('提交中...');
                this.$axios.post("240words/submitQuiz",{
                    json:JSON.stringify(that.postDataArray)
                }).then((response)=>{
                    Indicator.close()
                    that.objWordsQuizResult = response.data;

                    if (that.getCount(that.objWordsQuizResult.wrongCount) == 0) {
                        window.LessonRefreshData = 1;
                    }
                });
            },
            getInputLetters:function() {
                let that = this;
                let vInputLetters = "";

                that.inputLettersArray.forEach((item) => {
                    vInputLetters += item.keyboardResult.value;
                })

                return vInputLetters;
            },
            playStart() {
                this.isPlaying = true;
            },
            playEnded() {
                this.isPlaying = false;
            },
            finishClick:function() {
                let that = this;
                that.$router.go(-1);
            },
            continueClick:function() {
                let that = this;
                that.wordIndex = 1;
                that.inputLettersArray = [];
                that.objWordsQuizResult = null;
                that.getQuiz(0);
            },
            restartClick:function() {
                let that = this;
                that.wordIndex = 1;
                that.inputLettersArray = [];
                that.objWordsQuizResult = null;
                that.getQuiz(1);
            },
            getQuiz:function (deleteRecords) {
                let that = this;
                let url = getUrl(that.lessonId, deleteRecords);

                this.$axios.get(url).then((response) => {
                    that.wordsQuizArray = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            getKeyboardLettersSize() {
                let that = this;
                let vNum = that.keyboardLettersRowCount;
                return 'calc((100% - ' + 2*15 + 'px - ' + (vNum - 1)*5 + 'px)/' + vNum + ')';
            },
            isSpecialChar:function(item) {
                return item === '-'|| item === ' ';
            },
            getInputSize:function() {
                let that = this;
                let vNum = that.getInputColumnNum();
                return 'calc((100% - ' + 2*15 + 'px - ' + (vNum - 1)*5 + 'px)/' + vNum + ')';
            },
            getInputColumnNum:function() {
                let that = this;
                let vWord = that.getWord()
                let vWordLength = vWord.length;

                return vWordLength <= 9 ? 9 : vWordLength;
            },
            getKeyboardLettersArray:function() {
                let that = this;
                let objWordsQuiz = that.getWordsQuiz()

                if (objWordsQuiz == null) {
                    return "";
                }

                return objWordsQuiz.keyboardLetters.split(',');
            },
            isFinishInput:function() {
                let that = this;
                let vNoSeparatorCharCount = that.getNoSeparatorCharCount();

                if (that.isEmpty(that.inputLettersArray)) {
                    return false;
                }

                return vNoSeparatorCharCount === that.inputLettersArray.length;
            },
            getNoSeparatorCharCount:function() {
                let that = this;
                let objWordsQuiz = that.getWordsQuiz()

                if (objWordsQuiz == null) {
                    return "";
                }

                return parseInt(objWordsQuiz.noSeparatorCharCount);
            },
            getWord:function() {
                let that = this;
                let objWordsQuiz = that.getWordsQuiz()

                if (objWordsQuiz == null) {
                    return "";
                }

                return objWordsQuiz.word;
            },
            getWordsQuiz:function () {
                let that = this;
                return that.wordsQuizArray[that.wordIndex - 1]
            },
            getAudioUrl:function () {
                let that = this;
                let objWordsQuiz = that.getWordsQuiz()

                if (objWordsQuiz == null) {
                    return "";
                }

                return this.$qiNiuDomainBase + objWordsQuiz.audio;
            },
            getImgUrl:function () {
                let that = this;
                let objWordsQuiz = that.getWordsQuiz()

                if (objWordsQuiz == null) {
                    return "";
                }

                return this.$qiNiuDomainBase + objWordsQuiz.picture;
            },
            playAudio:function () {
                const musicMp3 = document.getElementById('musicMp3')
                musicMp3.play()
            },
            forInputLetterId:function(index) {
                let that = this;
                return that.forInputLetterBase + index
            },
            removeAt:function(array, index) {
                if (isNaN(index) || index >= array.length) {
                    return false;
                }
                array.splice(index, 1);
            },
            inputLetterClick:function (index) {
                let that = this;
                that.inputLetterGuideClick();
                let vItemInput = $("#" + that.forInputLetterBase + index).html();

                if (vItemInput.length == 0) {
                    return;
                }

                let vTempIndex = -1;

                that.inputLettersArray.forEach((obj, idx) => {
                    if (obj.inputIndex === index && obj.keyboardResult.value === vItemInput) {
                        vTempIndex = idx;
                    }
                })

                if (vTempIndex === -1) {
                    return;
                }

                that.removeAt(that.inputLettersArray, vTempIndex);
            },
            getCurrentInputLetter:function(index) {
                let that = this;
                let strInputLetter = "";

                if (that.inputLettersArray == null || that.inputLettersArray.length == 0) {
                    return strInputLetter;
                }

                that.inputLettersArray.forEach(item => {
                    if (item.inputIndex === index) {
                        strInputLetter = item.keyboardResult.value;
                    }
                })

                return strInputLetter;
            },
            isContainkeyboardLetter:function(index, value) {
                let that = this;
                let vResult = false;
                if (that.inputLettersArray == null || that.inputLettersArray.length == 0) {
                    return vResult;
                }

                that.inputLettersArray.forEach(item => {
                  if (item.keyboardResult.key === index && item.keyboardResult.value === value) {
                      vResult = true;
                  }
                })

                return vResult;
            },
            keyboardLettersClick:function (index, item) {
                let that = this;
                that.keyBoardLetterGuideClick();

                // 已经输入不能再添加
                if (that.isContainkeyboardLetter(index, item)) {
                  return;
                }

                let vWord = that.getWord();
                let vInputIndex = -1;

                for(let i = 0; i < vWord.length; i++) {
                    let vItemInput = $("#" + that.forInputLetterBase + i).html();

                    if (vItemInput.length == 0) {
                        vInputIndex = i;
                        break;
                    }
                }

                if (vInputIndex == -1) {
                    return;
                }

                that.inputLettersArray.push({inputIndex:vInputIndex, keyboardResult:{key:index, value:item}});
            }
        },
        beforeCreate () {
            let vCourseId = parseInt(this.$route.query.courseId);
            let vlessonId = parseInt(this.$route.query.lessonId);
            let vQuizCount = parseInt(this.$route.query.quizCount);
            let vLessonTitle = this.$route.query.lessonTitle;
            let that = this;
            let url = getUrl(vlessonId, 0);

            this.$axios.get(url).then((response) => {
                that.isNoGetData = false;
                that.wordsQuizArray = response.data;
                that.courseId = vCourseId;
                that.lessonId = vlessonId;
                that.quizCount = vQuizCount;
                that.lessonTitle = vLessonTitle;

                if(!that.isEmpty(that.wordsQuizArray)) {
                    let objWordsQuiz = that.wordsQuizArray[0];
                    that.noShowGuideInputLetter = that.getCount(objWordsQuiz.key5);
                    that.noShowGuidekeyBoardLetter = that.getCount(objWordsQuiz.key6);
                }

                window.LessonRefreshData = 0;
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>

.navigation {
    position: relative;
}
.navigation .left {
    float: left;
    width: 50px;
    height: 44px;
    color: white;
    font-size: 25px;
    text-align: center;
    line-height: 44px;
}

.navigation .left img {
    width: 30px;
    height: 30px;
    margin-top: 9px;
}

.navigation .content {
    float: left;
    height: 100%;
    width: calc(100% - 50px - 80px - 15px);
    text-align: center;
    line-height: 44px;
    color: white;
    font-size: 20px;
}
.navigation .right {
    width: 80px;
    height: 30px;
    float: right;
    position: absolute;
    right: 15px;
    top: 50%;
    -webkit-transform:translateY(-50%);
    border-radius: 13px;
    -webkit-border-radius: 13px;
    -moz-border-radius: 13px;
    background-color: #d4d4d4;
    font-size: 16px;
    font-weight: bold;
    color: #999999;
    text-align: center;
    line-height: 30px;
}

.navigation .right_post {
    width: 80px;
    height: 30px;
    float: right;
    position: absolute;
    right: 15px;
    top: 50%;
    -webkit-transform:translateY(-50%);
    border-radius: 13px;
    -webkit-border-radius: 13px;
    -moz-border-radius: 13px;
    background-color: #FFAA00;
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: center;
    line-height: 30px;
}

.quiz_main{
    position:absolute;
    width:100%;
    height:auto;
    min-height: 100%;
    text-align: center;
}
.quiz_main_content {
    max-width: 500px;
    width: 100%;
    position: relative;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main .Page_num {
    position: relative;
    left: 0px;
    margin-top: 10px;
    color: white;
    font-size: 18px;
    font-weight: bold;
    height: 36px;
}
.quiz_main .Page_num .content_center {
    display: inline-block;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main .Page_num span {
    font-size: 28px;
    font-weight: bold;
}
.quiz_main .imgLazyLoadHead {
    position: relative;
    margin: 10px 65px 0px 65px;
}
.quiz_main .imgLazyLoadHead .img_show {
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    width: 100%;
    margin: auto;
}
.quiz_main .imgLazyLoadHead .img_play {
    position: absolute;
    right: 15px;
    top: 15px;
}
audio {
    display: none;
}
.input_letter {
    position: relative;
    width:100%;
    margin: 30px 0px 0px 0px;
}
.input_letter .input_letter_item {
    display: inline-block;
    position: relative;
    height: 0px;
}
.input_letter .input_letter_itembg {
    background-image: url(../../../assets/words_course_quizinput.png);
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
}
.input_letter .input_letter_item span {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    font-size: 20px;
    font-weight: bold;
    color: white;
}
.keyboard_letters2 {
    position: relative;
}
.keyboard_letters {
    width:100%;
    margin: 30px 0px 50px 0px;
}
.keyboard_letters .keyboard_letters_item {
    display: inline-block;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    height: 0px;
    position: relative;
}

.keyboard_letters .keyboard_letters_item span {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}
.quiz_main_right {
    max-width: 500px;
    position: relative;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main_right .content {
    padding-bottom: 100%;
    width: 86%;
    height: 0;
    background-color: white;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    position: relative;
    top: 90px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    max-width: 400px;
}
.quiz_main_right .img {
    position: absolute;
    top: 25px;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main_right .img img {
    width: 55%;
}
.quiz_main_right .content .answer .answer_right {
    float: left;
    width: 50%;
    text-align: center;
    color: #64c846;
    font-size: 20px;
    font-weight: bold;
}
.quiz_main_right .content .answer .answer_wrong {
    float: right;
    width: 50%;
    color:#ff5050;
    font-size: 20px;
    font-weight: bold;
}
.quiz_main_right .content .top {
    height: 0px;
    padding-bottom: 20%;
}

.quiz_main_right .content .tip {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    width: 80%;
    font-size: 20px;
    font-weight: bold;
    color:#ff5050;
}
.quiz_main_right .content .finish {
    position: absolute;
    bottom: 90px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    height: 40px;
    line-height: 40px;
    width: calc(100% - 60px);
    color: white;
    background-color: #64c846;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    font-size: 18px;
    font-weight: bold;
}
.quiz_main_right .content .restart {
    position: absolute;
    bottom: 30px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    height: 40px;
    line-height: 40px;
    width: calc(100% - 60px);
    color: #ff5050;
    border: 1px solid #ff5050;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    font-size: 18px;
    font-weight: bold;
}
.quiz_main_wrong {
    max-width: 500px;
    position: relative;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main_wrong .content {
    padding-bottom: 100%;
    width: 86%;
    height: 0;
    background-color: white;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    position: relative;
    top: 90px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    max-width: 400px;
}
.quiz_main_wrong .img {
    position: absolute;
    top: 30px;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.quiz_main_wrong .img img {
    width: 180px;
    height: 140px;
}
.quiz_main_wrong .content .answer .answer_right {
    float: left;
    width: 50%;
    text-align: center;
    color: #64c846;
    font-size: 20px;
    font-weight: bold;
}
.quiz_main_wrong .content .answer .answer_wrong {
    float: right;
    width: 50%;
    color:#ff5050;
    font-size: 20px;
    font-weight: bold;
}
.quiz_main_wrong .content .top {
    height: 0px;
    padding-bottom: 20%;
}
.quiz_main_wrong .content .tip {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    width: 80%;
    font-size: 16px;
    color:#333333;
    text-align: center;
}
.quiz_main_wrong .content .tip span {
    font-size: 20px;
    font-weight: bold;
    color:#333333;
}
.quiz_main_wrong .content .continue {
    position: absolute;
    bottom: 30px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    height: 40px;
    line-height: 40px;
    width: calc(100% - 60px);
    color: white;
    background-color: #64c846;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    font-size: 18px;
    font-weight: bold;
}
.bubbleContainer{
    position: absolute;
    top: -35px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    padding-bottom: 12px;
}
.bubbleContainer .text {
    color: white;
    background-color: #fda228;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    padding: 3px 15px 3px 15px;
    font-size: 15px;
    font-weight: bold;
}
.bubbleContainer .img {
    position: absolute;
    bottom: 0px;
    width: 12px;
    left: 50%;
    -webkit-transform: translateX(-50%);
}
.bubbleContainer .img img {
    width: 12px;
}

</style>
